import axios from "axios";

export const requestMixin = {
  data: function () {
    return {
      response: 'Click on the "Run" button to see results',
    };
  },
  computed: {
    proxyUrl: function () {
      return this.proxyUrlBase + this.requestUrl;
    },
  },
  methods: {
    runRequest: function () {
      this.response = "Loading";
      var params;

      if (this.method === "get") {
        params = {};
        this.urlParams.forEach((param) => {
          var valueProperty = param.type === "File" ? "file" : "value";
          if (param[valueProperty]) {
            params[param.varName] = param[valueProperty];
          }
        });

        return axios
          .get(this.proxyUrl, { auth: this.auth, params: params })
          .then((response) => {
            this.response = response.data;

            if (this.response.result.length) {
              var result = this.response.result[0];
              if (result.metadata) {
                var metadata = result.metadata;
                metadata.filepath = result.filepath;
                this.$emit("update-metadata", metadata);
              }
            }

            return response.data;
          })
          .catch((err) => {
            this.response = err;
          });
      } else if (this.method === "post") {
        params = new FormData();
        this.urlParams.forEach((param) => {
          var valueProperty = param.type === "File" ? "file" : "value";

          if (param.varName === "ignore_background") {
            params.append(param.varName, param.value.toString());
          }

          if (param.varName === "ignore_interior_background") {
            params.append(param.varName, param.value.toString());
          }

          if (param[valueProperty]) {
            params.append(param.varName, param[valueProperty]);
          }
        });

        return axios
          .post(this.proxyUrl, params, {
            auth: this.auth,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.response = response.data;

            if (this.response.result.length) {
              var result = this.response.result[0];
              if (result.metadata) {
                var metadata = result.metadata;
                metadata.filepath = result.filepath;
                this.$emit("update-metadata", metadata);
              }
            }

            return response.data;
          })
          .catch((err) => {
            this.response = err;
          });
      } else {
        this.response = "Error: unsupported method " + this.method;
      }
    },
  },
};
